import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../services/auth.service';
import { GlobalService } from '../services/global.service';
import { ToastrMessageType } from '../enums/toastr-message-type.enum';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private globalService: GlobalService,
    private authService: AuthService,
    private router: Router) {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isTokenExpired()) {
      this.globalService.showMessage('Session Expired.', ToastrMessageType.Info);
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }
}
